import script from "./FormTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./FormTemplate.vue?vue&type=style&index=0&id=7a10b771&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a10b771"]])

export default __exports__